import React, { useState, useEffect, useRef, useCallback } from 'react';
import debounce from 'lodash-es/debounce';
import axios from 'axios';
import { Select, Col, Tooltip, Row, Spin, TreeSelect, Button, version, Form, Modal, Card, Input, Space, Checkbox, Empty, Tree, Tag } from 'antd';
import { isEmpty, indexOf, groupBy as groupBy$1 } from 'lodash-es';
import Mustache from 'mustache';
import Dexie from 'dexie';
import each from 'lodash-es/each';
import groupBy from 'lodash-es/groupBy';
import isArray from 'lodash-es/isArray';
import eq from 'lodash-es/eq';
import isEmpty$1 from 'lodash-es/isEmpty';
import uniqBy from 'lodash-es/uniqBy';
import { SearchOutlined } from '@ant-design/icons';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Option = Select.Option;
function getWholeUrlFromOptions(options) {
  return options.url + "?carrierId=" + options.params.carrierId + "&category=" + options.params.category + "&memship=" + options.params.memship + "&sortField=" + options.params.sortField + "&sortDir=" + options.params.sortDir + "&linerGroup=" + options.params.linerGroup + "&distinctField=" + options.params.distinctField + "}&kind=" + options.params.kind;
}
function concatItem(following, original) {
  return following ? original.concat(following) : original;
}
function removeDuplicateItem(items, itemValueField) {
  var unduplicatedValues = [];
  items.forEach(function (item) {
    if (!unduplicatedValues.find(function (unduplicatedItem) {
      return item[itemValueField] === unduplicatedItem[itemValueField];
    })) {
      unduplicatedValues.push(item);
    }
  });
  return unduplicatedValues;
}
function getCombinedItems(cmpClass) {
  var items = removeDuplicateItem(concatItem(cmpClass.state.items, concatItem(cmpClass.props.cachedValues, cmpClass.state.selectedValues)), cmpClass.props.valueField);
  return items;
}
function constructChildFromItem(item, props, disabled) {
  var child = null;
  if (props.tableConfig) {
    var cols = props.tableConfig.map(function (column) {
      return React.createElement(Col, {
        flex: column.width,
        style: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        },
        key: "" + column.title + item[props.valueField]
      }, constructInnerContent(column.toolTip, compileTemplate(item, column.tpl)));
    });
    child = React.createElement(Row, {
      key: item[props.valueField]
    }, cols);
  } else if (props.tpl) {
    child = React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: compileTemplate(item, props.tpl)
      }
    });
  } else {
    child = item[props.displayField];
  }
  return React.createElement(Option, {
    value: item[props.valueField],
    label: props.displayTpl ? compileTemplate(item, props.displayTpl) : item[props.displayField],
    key: item[props.valueField],
    "data-object": item,
    disabled: disabled
  }, child);
}
function constructInnerContent(toolTip, text) {
  return toolTip ? React.createElement(Tooltip, {
    title: text,
    placement: "topLeft"
  }, React.createElement("span", null, text)) : text;
}
function constructParamStringFromObj(obj) {
  return obj && obj.toString() === '[object Object]' ? Object.keys(obj).reduce(function (accumulator, key) {
    if (obj[key]) {
      accumulator.push(key);
    }
    return accumulator;
  }, []).join(';') : obj;
}
function compileTemplate(item, tpl) {
  if (!isEmpty(tpl) && indexOf(tpl, "$") > -1) {
    tpl = tpl.replace(/\${/gi, '{{{').replace(/}/gi, '}}}');
  }
  Mustache.parse(tpl);
  return Mustache.render(tpl, {
    item: item
  });
}
function initCommonData(key, props, setItems, options) {
  var oneDayInMs = 1000 * 60 * 60 * 24;
  var db = new Dexie('ccdDB');
  db.version(1).stores({
    ccdTable: ''
  });
  db.table('ccdTable').get(key).then(function (cache) {
    if (cache && new Date().getTime() - cache.cacheTime < oneDayInMs) {
      if (null != props.filterBy && typeof props.filterBy === 'function') {
        var filterData = props.filterBy(cache.data, props.filterParam);
        setItems(filterData);
      } else {
        setItems(cache.data);
      }
    } else {
      axios(options).then(function (response) {
        if (null != props.filterBy && typeof props.filterBy === 'function') {
          var _filterData = props.filterBy(response.data.results, props.filterParam);
          setItems(_filterData);
        } else {
          setItems(response.data.results);
        }
        db.table('ccdTable').put({
          data: response.data.results,
          cacheTime: new Date().getTime()
        }, key);
      });
    }
  })["catch"](function () {
    axios(options).then(function (response) {
      if (null != props.filterBy && typeof props.filterBy === 'function') {
        var filterData = props.filterBy(response.data.results, props.filterParam);
        setItems(filterData);
      } else {
        setItems(response.data.results);
      }
    });
  });
}

var _excluded = ["linerGroup", "carrierId", "domain", "bizType", "valueField", "displayField", "minChars", "notAllowChars", "filterBy", "clearOptionsAfterBlur", "beforeSearch", "maxSelectCount", "hierarchy", "unitType", "limit", "geographicTypeKeys", "geoServices", "category", "excludeCategories", "cityWithActiveFacility", "coreStatus", "verification", "finconState", "salesState", "docState", "csvState", "queue", "docTypeCode", "officeCode", "memship", "cachedValues", "displayTpl", "tpl", "tableConfig", "transportation", "nontransportation", "liner", "logistic", "supplierTypes", "onChange", "onSearch", "onFocus", "onBlur"];
var lastQueryToken = 0;
var IrisSelect = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(IrisSelect, _React$Component);
  function IrisSelect(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      items: [],
      fetching: false,
      selectedValues: []
    };
    _this.handleSearch = function (value) {
      if (value) {
        if (_this.props.minChars && value.length < _this.props.minChars) {
          return;
        }
        if (_this.props.notAllowChars && new RegExp("[" + _this.props.notAllowChars + "]").test(value)) {
          alert('Cannot contains text with ' + _this.props.notAllowChars);
          return;
        }
        if (_this.props.beforeSearch) {
          value = _this.props.beforeSearch(value);
        }
        _this.setState({
          fetching: true
        });
        var queryToken = ++lastQueryToken;
        var options = {
          method: 'GET',
          baseURL: _this.props.baseUrl ? _this.props.baseUrl : '/ccdGateway',
          params: {
            queryText: value,
            queryToken: queryToken,
            carrierId: _this.props.carrierId,
            hierarchy: _this.props.hierarchy,
            unitType: _this.props.unitType,
            limit: _this.props.limit,
            geographicTypeKeys: constructParamStringFromObj(_this.props.geographicTypeKeys),
            geoServices: constructParamStringFromObj(_this.props.geoServices),
            category: _this.props.category,
            excludeCategories: constructParamStringFromObj(_this.props.excludeCategories),
            hasActiveFacility: _this.props.cityWithActiveFacility,
            coreStatus: _this.props.coreStatus,
            verification: _this.props.verification,
            finconState: _this.props.finconState,
            salesState: _this.props.salesState,
            docState: _this.props.docState,
            csvState: _this.props.csvState,
            queue: _this.props.queue,
            docTypeCode: _this.props.docTypeCode,
            officeCode: _this.props.officeCode,
            memship: _this.props.memship,
            linerGroup: _this.props.linerGroup,
            transportation: _this.props.transportation,
            nontransportation: _this.props.nontransportation,
            liner: _this.props.liner,
            logistic: _this.props.logistic,
            supplierTypes: _this.props.supplierTypes
          },
          url: "/" + _this.props.domain + "/" + _this.props.bizType,
          withCredentials: true
        };
        axios(options).then(function (response) {
          if (lastQueryToken.toString() === response.data.queryToken) {
            if (null != _this.props.filterBy && typeof _this.props.filterBy === 'function') {
              _this.setState({
                items: _this.props.filterBy(response.data.results),
                fetching: false
              });
            } else {
              _this.setState({
                items: response.data.results,
                fetching: false
              });
            }
          }
        });
      } else {
        _this.setState({
          items: []
        });
      }
    };
    _this.handleChange = function (value, option) {
      var values = getCombinedItems(_assertThisInitialized(_this)).filter(function (item) {
        return value && (Array.isArray(value) && value.includes(item[_this.props.valueField]) || value == item[_this.props.valueField]);
      });
      _this.props.onChange && _this.props.onChange(value, option, values);
      _this.setState({
        selectedValues: values
      });
    };
    _this.handleBlur = function () {
      if (_this.props.clearOptionsAfterBlur) {
        _this.setState({
          items: []
        });
      }
      _this.props.onBlur && _this.props.onBlur();
    };
    _this.handleFocus = function () {
      if (_this.props.value) {
        var selectKey = _this.props.value;
        _this.setState({
          selectedValues: getCombinedItems(_assertThisInitialized(_this)).filter(function (item) {
            return selectKey && (Array.isArray(selectKey) && selectKey.includes(item[_this.props.valueField]) || selectKey === item[_this.props.valueField]);
          })
        });
      } else {
        _this.setState({
          selectedValues: []
        });
      }
      _this.props.onFocus && _this.props.onFocus();
    };
    _this.filterOption = function (_inputValue, option) {
      for (var i = 0; i < _this.state.items.length; i++) {
        if (option['value'] == _this.state.items[i][_this.props.valueField]) {
          return true;
        }
      }
      return false;
    };
    _this.handleSearch = debounce(_this.handleSearch, 800);
    return _this;
  }
  var _proto = IrisSelect.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      remainProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var children = getCombinedItems(this).map(function (item) {
      var disabled = false;
      if (Array.isArray(_this2.state.selectedValues) && _this2.props.maxSelectCount) {
        disabled = _this2.state.selectedValues.length >= _this2.props.maxSelectCount && !_this2.state.selectedValues.includes(item);
      }
      return constructChildFromItem(item, _this2.props, disabled);
    });
    return React.createElement(Select, Object.assign({
      showSearch: true,
      filterOption: this.filterOption,
      onSearch: this.handleSearch,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      optionLabelProp: 'label',
      notFoundContent: this.state.fetching ? React.createElement(Spin, {
        size: "small"
      }) : undefined,
      loading: this.state.fetching,
      dropdownRender: function dropdownRender(menu) {
        var child = null;
        if (_this2.props.tableConfig) {
          var headers = _this2.props.tableConfig.map(function (column) {
            return React.createElement(Col, {
              key: column.title,
              flex: column.width
            }, React.createElement("b", null, column.title));
          });
          child = React.createElement("div", null, React.createElement(Row, {
            key: "header",
            style: {
              marginLeft: '12px'
            }
          }, headers), menu);
        } else {
          child = menu;
        }
        return _this2.state.fetching ? React.createElement(Spin, {
          style: {
            padding: '15px'
          },
          size: "small",
          spinning: _this2.state.fetching
        }) : child;
      }
    }, remainProps), children);
  };
  return IrisSelect;
}(React.Component);

var _excluded$1 = ["linerGroup", "displayTpl", "tpl", "baseUrl", "valueField", "displayField", "filterBy", "filterParam"];
var ItsSvvdSelect = function ItsSvvdSelect(props) {
  return React.createElement(IrisSelect, Object.assign({
    domain: 'its',
    bizType: 'svvd',
    valueField: 'voyageCode',
    displayField: 'voyageCode'
  }, props));
};
var ItsServiceLoopSelect = function ItsServiceLoopSelect(props) {
  return React.createElement(IrisSelect, Object.assign({
    domain: 'its',
    bizType: 'svcLoop',
    valueField: 'code',
    displayField: 'name'
  }, props));
};
var ItsVesselSelect = function ItsVesselSelect(props) {
  return React.createElement(IrisSelect, Object.assign({
    domain: 'its',
    bizType: 'vessel',
    valueField: 'code',
    displayField: 'name'
  }, props));
};
var ItsVesselOperatorSelect = function ItsVesselOperatorSelect(props) {
  var remainProps = _objectWithoutPropertiesLoose(props, _excluded$1);
  var _useState = useState([]),
    items = _useState[0],
    setItems = _useState[1];
  useEffect(function () {
    var url = "/its/vesselOperators";
    var options = {
      method: 'GET',
      baseURL: props.baseUrl ? props.baseUrl : '/ccdGateway',
      url: url,
      withCredentials: true,
      params: {
        linerGroup: props.linerGroup
      }
    };
    initCommonData(url, props, setItems, options);
    return undefined;
  }, [props]);
  var children = items.map(function (item) {
    return constructChildFromItem(item, props, false);
  });
  return React.createElement(Select, Object.assign({
    optionLabelProp: 'label'
  }, remainProps), children);
};

var _excluded$2 = ["linerGroup", "displayTpl", "tpl", "baseUrl", "valueField", "displayField", "filterBy", "filterParam"];
var GspOrgSelect = function GspOrgSelect(props) {
  return React.createElement(IrisSelect, Object.assign({
    domain: 'gsp',
    bizType: 'org',
    valueField: 'id',
    displayField: 'name'
  }, props));
};
var GspGeoSelect = function GspGeoSelect(props) {
  return React.createElement(IrisSelect, Object.assign({
    domain: 'gsp',
    bizType: 'geo',
    valueField: 'id',
    displayField: 'name'
  }, props));
};
var LocationTypeSelect = function LocationTypeSelect(props) {
  var remainProps = _objectWithoutPropertiesLoose(props, _excluded$2);
  var _useState = useState([]),
    items = _useState[0],
    setItems = _useState[1];
  useEffect(function () {
    var url = "/gsp/location-type?linerGroup=" + props.linerGroup;
    var options = {
      method: 'GET',
      baseURL: props.baseUrl ? props.baseUrl : '/ccdGateway',
      url: url,
      withCredentials: true
    };
    initCommonData(url, props, setItems, options);
    return undefined;
  }, [props]);
  var children = items.map(function (item) {
    return constructChildFromItem(item, props, false);
  });
  return React.createElement(Select, Object.assign({
    optionLabelProp: 'label'
  }, remainProps), children);
};

var CusCustomerSelect = function CusCustomerSelect(props) {
  return React.createElement(IrisSelect, Object.assign({
    domain: 'cus',
    bizType: 'customer',
    valueField: 'cpfId',
    displayField: 'customerName',
    tpl: '<b>${item.customerName}</b><p>${item.cpfId}, ${item.address.addressText}</p>'
  }, props));
};

var _excluded$3 = ["linerGroup", "carrierId", "valueField", "displayField", "category", "memship", "sortField", "sortDir", "displayTpl", "tpl", "filterBy", "filterParam", "distinctField", "baseUrl", "url", "kind"];
var CmnPrinterSelect = function CmnPrinterSelect(props) {
  return React.createElement(IrisSelect, Object.assign({
    domain: 'cmn',
    bizType: 'printer',
    valueField: 'Id',
    displayField: 'Name'
  }, props));
};
var CmnDataSelect = function CmnDataSelect(props) {
  var remainProps = _objectWithoutPropertiesLoose(props, _excluded$3);
  var _useState = useState([]),
    items = _useState[0],
    setItems = _useState[1];
  useEffect(function () {
    var _props$url;
    var options = {
      method: 'GET',
      baseURL: props.baseUrl ? props.baseUrl : '/ccdGateway',
      params: {
        carrierId: props.carrierId,
        category: props.category,
        memship: props.memship || '',
        linerGroup: props.linerGroup,
        sortField: props.sortField || '',
        sortDir: props.sortDir ? props.sortDir : 'ASC',
        distinctField: props.distinctField || '',
        kind: props.kind
      },
      url: (_props$url = props.url) != null ? _props$url : "/cmn/data",
      withCredentials: true
    };
    var key = getWholeUrlFromOptions(options);
    initCommonData(key, props, setItems, options);
    return undefined;
  }, [props]);
  var children = items.map(function (item) {
    return constructChildFromItem(item, props, false);
  });
  return React.createElement(Select, Object.assign({
    optionLabelProp: 'label'
  }, remainProps), children);
};

var SppmSupplierSelect = function SppmSupplierSelect(props) {
  return React.createElement(IrisSelect, Object.assign({
    domain: 'sppm',
    bizType: 'supplier',
    valueField: 'id',
    displayField: 'name',
    dropdownMatchSelectWidth: 600,
    displayTpl: "{{#item.code}}{{{item.code}}}-{{/item.code}}{{{item.controlOfficeCode}}}-{{{item.name}}}",
    tableConfig: [{
      title: 'Code',
      tpl: "${item.code}",
      width: '80px',
      toolTip: false
    }, {
      title: 'Control Office',
      tpl: '${item.controlOfficeCode}',
      width: '120px',
      toolTip: true
    }, {
      title: 'Display Name',
      tpl: '${item.name}',
      width: '170px',
      toolTip: true
    }, {
      title: 'Id',
      tpl: '${item.id}',
      width: '150px',
      toolTip: true
    }]
  }, props));
};

var _excluded$4 = ["liner", "searchType", "valueField", "displayField", "minChars", "limit", "cachedValues", "displayTpl", "tpl", "tableConfig", "onChange"];
var lastQueryToken$1 = 0;
var UserSelect = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(UserSelect, _React$Component);
  function UserSelect(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      items: [],
      fetching: false,
      selectedValues: []
    };
    _this.handleSearch = function (value) {
      if (value) {
        if (_this.props.minChars && value.length < _this.props.minChars) {
          return;
        }
        _this.setState({
          fetching: true
        });
        var queryToken = ++lastQueryToken$1;
        var options = {
          method: 'GET',
          baseURL: _this.props.baseUrl ? _this.props.baseUrl : '/dhupGateway',
          params: {
            userIds: _this.props.searchType === 'id' ? value : null,
            userNames: _this.props.searchType === 'name' ? value : null,
            queryToken: queryToken,
            liner: _this.props.liner.toUpperCase(),
            size: _this.props.limit,
            page: _this.props.limit ? 1 : null
          },
          url: '/users/internal/oneSystem',
          withCredentials: true
        };
        axios(options).then(function (response) {
          if (lastQueryToken$1.toString() === response.headers['querytoken'].toString()) {
            _this.setState({
              items: response.data,
              fetching: false
            });
          }
        });
      } else {
        _this.setState({
          items: []
        });
      }
    };
    _this.handleChange = function (value, option) {
      var values = getCombinedItems(_assertThisInitialized(_this)).filter(function (item) {
        return value && (Array.isArray(value) && value.includes(item[_this.props.valueField]) || value == item[_this.props.valueField]);
      });
      _this.props.onChange && _this.props.onChange(value, option, values);
      _this.setState({
        selectedValues: values
      });
    };
    _this.filterOption = function (_inputValue, option) {
      for (var i = 0; i < _this.state.items.length; i++) {
        if (option['value'] == _this.state.items[i][_this.props.valueField]) {
          return true;
        }
      }
      return false;
    };
    _this.handleSearch = debounce(_this.handleSearch, 800);
    return _this;
  }
  var _proto = UserSelect.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      remainProps = _objectWithoutPropertiesLoose(_this$props, _excluded$4);
    var children = getCombinedItems(this).map(function (item) {
      return constructChildFromItem(item, _this2.props, false);
    });
    return React.createElement(Select, Object.assign({
      showSearch: true,
      onSearch: this.handleSearch,
      onChange: this.handleChange,
      filterOption: this.filterOption,
      optionLabelProp: 'label',
      notFoundContent: this.state.fetching ? React.createElement(Spin, {
        size: "small"
      }) : undefined,
      loading: this.state.fetching,
      dropdownRender: function dropdownRender(menu) {
        var child = null;
        if (_this2.props.tableConfig) {
          var headers = _this2.props.tableConfig.map(function (column) {
            return React.createElement(Col, {
              key: column.title,
              flex: column.width
            }, React.createElement("b", null, column.title));
          });
          child = React.createElement("div", null, React.createElement(Row, {
            key: "header",
            style: {
              marginLeft: '12px'
            }
          }, headers), menu);
        } else {
          child = menu;
        }
        return _this2.state.fetching ? React.createElement(Spin, {
          style: {
            padding: '15px'
          },
          size: "small",
          spinning: _this2.state.fetching
        }) : child;
      }
    }, remainProps), children);
  };
  return UserSelect;
}(React.Component);

var SalesSelect = function SalesSelect(props) {
  return React.createElement(IrisSelect, Object.assign({
    domain: 'sal',
    bizType: 'sales',
    valueField: 'salesId',
    displayField: 'name'
  }, props));
};

var _excluded$5 = ["carrierIds", "trades", "tariffStatus", "displayTpl", "tpl", "baseUrl", "valueField", "displayField", "filterBy", "filterParam"];
var TariffDataSelect = function TariffDataSelect(props) {
  var remainProps = _objectWithoutPropertiesLoose(props, _excluded$5);
  var _useState = useState([]),
    items = _useState[0],
    setItems = _useState[1];
  useEffect(function () {
    var options = {
      method: 'POST',
      baseURL: props.baseUrl ? props.baseUrl : '/ccdGateway',
      data: {
        carrierIds: props.carrierIds,
        trades: props.trades,
        status: props.tariffStatus
      },
      url: "/rnc/tariff/tariffs/search",
      withCredentials: true
    };
    var oneDayInMs = 1000 * 60 * 60 * 24;
    var db = new Dexie('ccdDB');
    db.version(1).stores({
      ccdTable: ''
    });
    var key = "/rnc/tariff/tariffs/search?carrierIds=" + props.carrierIds + "&trades=" + props.trades + "&status=" + props.tariffStatus;
    db.table('ccdTable').get(key).then(function (cache) {
      if (cache && new Date().getTime() - cache.cacheTime < oneDayInMs) {
        if (null != props.filterBy && typeof props.filterBy === 'function') {
          var filterData = props.filterBy(cache.data, props.filterParam);
          setItems(filterData);
        } else {
          setItems(cache.data);
        }
      } else {
        axios(options).then(function (response) {
          if (null != props.filterBy && typeof props.filterBy === 'function') {
            var _filterData = props.filterBy(response.data, props.filterParam);
            setItems(_filterData);
          } else {
            setItems(response.data);
          }
          db.table('ccdTable').put({
            data: response.data,
            cacheTime: new Date().getTime()
          }, key);
        });
      }
    })["catch"](function () {
      axios(options).then(function (response) {
        if (null != props.filterBy && typeof props.filterBy === 'function') {
          var filterData = props.filterBy(response.data, props.filterParam);
          setItems(filterData);
        } else {
          setItems(response.data);
        }
      });
    });
    return undefined;
  }, [props]);
  var children = items.map(function (item) {
    return constructChildFromItem(item, props, false);
  });
  return React.createElement(Select, Object.assign({
    optionLabelProp: 'label'
  }, remainProps), children);
};
var AgreementSelect = function AgreementSelect(props) {
  function beforeAgreementSearch(value) {
    if (!value) {
      return value;
    }
    var inputAgreements = value.split(/[;,]/);
    var changedAgreements = [];
    var numberTest = /^[0-9]*$/;
    each(inputAgreements, function (inputAgreement) {
      if (numberTest.test(inputAgreement)) {
        var countNumber = inputAgreement.length;
        if (countNumber < 8) {
          while (8 - countNumber > 0) {
            inputAgreement = '0' + inputAgreement;
            countNumber++;
          }
        }
      }
      changedAgreements.push(inputAgreement);
    });
    return changedAgreements.join(";");
  }
  return React.createElement(IrisSelect, Object.assign({
    domain: 'rnc',
    bizType: 'agreements',
    valueField: 'agreementId',
    displayField: 'agreementId',
    beforeSearch: beforeAgreementSearch
  }, props));
};

var _excluded$6 = ["freeInput", "style", "value", "onChange", "treeLine"];
var buildKey = function buildKey(item) {
  return item.code || item.name;
};
var buildOptions = function buildOptions(items, keyword) {
  var segGroup = groupBy(items, function (item) {
    return item.segment.name;
  });
  var options = [];
  for (var _i = 0, _Object$values = Object.values(segGroup); _i < _Object$values.length; _i++) {
    var segments = _Object$values[_i];
    var segRef = segments[0];
    options.push({
      value: buildKey(segRef.segment),
      title: titleRender(segRef.segment, keyword),
      children: buildSegChildrenOptions(segments, keyword)
    });
  }
  return options;
};
var buildSegChildrenOptions = function buildSegChildrenOptions(items, keyword) {
  var familyItems = items.filter(function (item) {
    return item.family;
  });
  var familyGroup = groupBy(familyItems, function (item) {
    return item.family.name;
  });
  var options = [];
  for (var _i2 = 0, _Object$values2 = Object.values(familyGroup); _i2 < _Object$values2.length; _i2++) {
    var families = _Object$values2[_i2];
    var familyRef = families[0];
    options.push({
      value: buildKey(familyRef.family),
      title: titleRender(familyRef.family, keyword),
      children: buildFamilyChildrenOptions(families, keyword)
    });
  }
  return options;
};
var buildFamilyChildrenOptions = function buildFamilyChildrenOptions(items, keyword) {
  var clazzItems = items.filter(function (item) {
    return item.clazz;
  });
  var clazzGroup = groupBy(clazzItems, function (item) {
    return item.clazz.name;
  });
  var options = [];
  for (var _i3 = 0, _Object$values3 = Object.values(clazzGroup); _i3 < _Object$values3.length; _i3++) {
    var clazzList = _Object$values3[_i3];
    var clazzRef = clazzList[0];
    options.push({
      value: buildKey(clazzRef.clazz),
      title: titleRender(clazzRef.clazz, keyword),
      children: buildClazzChildrenOptions(clazzList, keyword)
    });
  }
  return options;
};
var buildClazzChildrenOptions = function buildClazzChildrenOptions(items, keyword) {
  return items.filter(function (item) {
    return item.commodity;
  }).map(function (item) {
    return {
      value: buildKey(item.commodity),
      title: titleRender(item.commodity, keyword),
      children: []
    };
  });
};
var buildTreeExpandKeys = function buildTreeExpandKeys(items) {
  var keySet = new Set();
  items.filter(function (item) {
    return item.commodity;
  }).forEach(function (item) {
    keySet.add(buildKey(item.clazz));
    keySet.add(buildKey(item.family));
    keySet.add(buildKey(item.segment));
  });
  items.filter(function (item) {
    return !item.commodity && item.clazz;
  }).forEach(function (item) {
    keySet.add(buildKey(item.family));
    keySet.add(buildKey(item.segment));
  });
  items.filter(function (item) {
    return item.family && !item.clazz;
  }).forEach(function (item) {
    keySet.add(buildKey(item.segment));
  });
  return Array.from(keySet);
};
var buildCodeObjMap = function buildCodeObjMap(items) {
  var map = new Map();
  items.forEach(function (item) {
    item.segment && map.set(buildKey(item.segment), item.segment);
    item.family && map.set(buildKey(item.family), item.family);
    item.clazz && map.set(buildKey(item.clazz), item.clazz);
    item.commodity && map.set(buildKey(item.commodity), item.commodity);
  });
  return map;
};
var titleRender = function titleRender(codeNameDesc, keyword) {
  return React.createElement("div", null, React.createElement(Row, {
    align: "middle",
    style: {
      flexWrap: 'nowrap'
    }
  }, React.createElement(Col, {
    flex: "auto"
  }, React.createElement("div", {
    style: {
      textOverflow: 'ellipsis',
      overflowX: 'hidden',
      paddingRight: '2px'
    }
  }, React.createElement("span", {
    title: codeNameDesc.name
  }, codeNameDesc.name.split(new RegExp("" + keyword.split(/\s+/).map(function (word) {
    return "(?<=" + word + ")|(?=" + word + ")";
  }).join("|"), 'ig')).map(function (str, i) {
    if (keyword.toLowerCase().split(/\s+/).includes(str.toLowerCase())) {
      return React.createElement("mark", {
        key: i
      }, str);
    }
    return React.createElement("span", {
      key: i
    }, str);
  })))), React.createElement(Col, {
    flex: "50px"
  }, React.createElement(Row, {
    justify: "center"
  }, codeNameDesc.bkgCount || 0)), React.createElement(Col, {
    flex: "50px"
  }, React.createElement(Row, {
    justify: "center"
  }, codeNameDesc.blCount || 0))));
};
var FREE_INPUT_IND = "[FreeInput]";
var CommoditySelect = function CommoditySelect(_ref) {
  var _ref$freeInput = _ref.freeInput,
    freeInput = _ref$freeInput === void 0 ? false : _ref$freeInput,
    style = _ref.style,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$treeLine = _ref.treeLine,
    treeLine = _ref$treeLine === void 0 ? true : _ref$treeLine,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var _useState = useState(false),
    fetching = _useState[0],
    setFetching = _useState[1];
  var _useState2 = useState([]),
    options = _useState2[0],
    setOptions = _useState2[1];
  var _useState3 = useState([]),
    selectedValue = _useState3[0],
    setSelectedValue = _useState3[1];
  var _useState4 = useState(''),
    searchValue = _useState4[0],
    setSearchValue = _useState4[1];
  var _useState5 = useState([]),
    treeExpandKey = _useState5[0],
    setTreeExpandKey = _useState5[1];
  var _useState6 = useState(new Map()),
    codeObjMap = _useState6[0],
    setCodeObjMap = _useState6[1];
  var searchValueRef = useRef('');
  useEffect(function () {
    setSelectedValue((value || []).map(function (v) {
      return {
        value: v.code || "" + FREE_INPUT_IND + v.name,
        label: v.name
      };
    }));
  }, [value]);
  var updateOptions = function updateOptions(data, searchValue) {
    if (searchValueRef.current === searchValue) {
      setOptions(buildOptions(data || [], searchValue.trim()));
      setTreeExpandKey(buildTreeExpandKeys(data || []));
      setCodeObjMap(buildCodeObjMap(data || []));
    }
  };
  var searchByKeyword = useCallback(debounce( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setFetching(true);
            _context.next = 3;
            return axios.request({
              method: 'get',
              withCredentials: true,
              url: "/ccdGateway/comi/commodity-library/commodities/component/search/basic",
              params: {
                cargoDesc: val
              }
            });
          case 3:
            response = _context.sent;
            updateOptions(response.data || [], val);
            setFetching(false);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), 800), []);
  var searchByAi = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setFetching(true);
            _context2.next = 3;
            return axios.request({
              method: 'get',
              withCredentials: true,
              url: "/ccdGateway/comi/commodity-library/commodities/component/search/advance",
              params: {
                cargoDesc: searchValue
              }
            });
          case 3:
            response = _context2.sent;
            updateOptions(response.data || [], searchValue);
            setFetching(false);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function searchByAi() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleSearch = function handleSearch(value) {
    searchValueRef.current = value;
    setSearchValue(value);
    if (!value) {
      setOptions([]);
    } else if (value.length >= 2) {
      searchByKeyword(value);
    }
  };
  var handleChange = function handleChange(value) {
    var newSelectedValue = value.map(function (v) {
      var _codeObjMap$get, _selectedValue$find;
      return {
        value: v.value,
        label: v.value.startsWith(FREE_INPUT_IND) ? v.value.split(FREE_INPUT_IND)[1] : ((_codeObjMap$get = codeObjMap.get(v.value)) == null ? void 0 : _codeObjMap$get.name) || ((_selectedValue$find = selectedValue.find(function (val) {
          return val.value === v.value;
        })) == null ? void 0 : _selectedValue$find.label) || ''
      };
    });
    setSelectedValue(newSelectedValue);
    setSearchValue("");
    searchValueRef.current = "";
    emitChange(newSelectedValue);
  };
  var emitChange = function emitChange(newSelectedValues) {
    onChange && onChange(newSelectedValues.map(function (v) {
      return {
        code: v.value.startsWith(FREE_INPUT_IND) ? null : v.value,
        name: v.label
      };
    }));
  };
  var onTreeExpand = function onTreeExpand(keys) {
    setTreeExpandKey(keys);
  };
  var onEnter = function onEnter(e) {
    var searchValueTrim = searchValue == null ? void 0 : searchValue.trim();
    if (e.key === 'Enter' && searchValueTrim) {
      if (!selectedValue.find(function (val) {
        return val.label === searchValueTrim;
      })) {
        var newSelectedValues = [].concat(selectedValue, [{
          value: "" + FREE_INPUT_IND + searchValueTrim,
          label: searchValueTrim
        }]);
        setSelectedValue(newSelectedValues);
        setOptions([{
          value: "" + FREE_INPUT_IND + searchValueTrim,
          title: searchValueTrim,
          children: []
        }].concat(options));
        emitChange(newSelectedValues);
      }
      setSearchValue("");
      searchValueRef.current = "";
    }
  };
  var dropdownRender = function dropdownRender(menu) {
    return fetching ? React.createElement(Spin, {
      style: {
        padding: '15px'
      },
      size: "small"
    }) : React.createElement(React.Fragment, null, React.createElement(Row, {
      style: {
        height: '30px',
        alignItems: 'center',
        backgroundColor: '#dfe4ea',
        padding: '0 10px',
        fontWeight: 'bold',
        color: '#2f3542',
        borderBottom: '1px solid #a4b0be'
      }
    }, React.createElement(Col, {
      flex: "auto"
    }, "Category/Commodity "), React.createElement(Col, {
      flex: "48px"
    }, React.createElement(Row, {
      justify: "center"
    }, "BKG")), React.createElement(Col, {
      flex: "45px"
    }, React.createElement(Row, {
      justify: "center"
    }, "BL"))), menu, React.createElement(Row, {
      style: {
        borderTop: '1px solid #c8d6e5',
        height: '24px',
        alignItems: 'center',
        padding: '4px 10px 0 10px'
      }
    }, React.createElement("span", {
      style: {
        color: '#747d8c'
      }
    }, "Cannot find commodity? Have a try"), React.createElement(Button, {
      size: "small",
      type: "dashed",
      style: {
        color: '#2980b9',
        fontWeight: 'bold',
        marginLeft: '4px'
      },
      onMouseDown: function onMouseDown(e) {
        return e.preventDefault();
      },
      onClick: searchByAi
    }, "AI Search")));
  };
  return React.createElement(TreeSelect, Object.assign({
    value: selectedValue,
    searchValue: freeInput ? searchValue : undefined,
    showSearch: true,
    multiple: true,
    labelInValue: true,
    filterTreeNode: false,
    notFoundContent: fetching ? React.createElement(Spin, {
      style: {
        padding: '15px'
      },
      size: "small"
    }) : undefined,
    style: _extends({
      width: '100%'
    }, style || {}),
    onSearch: handleSearch,
    onChange: handleChange,
    treeData: options,
    dropdownRender: dropdownRender,
    maxTagTextLength: 20,
    allowClear: true,
    onKeyDown: freeInput ? onEnter : undefined,
    treeExpandedKeys: treeExpandKey,
    onTreeExpand: onTreeExpand,
    treeLine: treeLine
  }, restProps));
};

var _excluded$7 = ["value", "onChange", "linerGroup"];
var HsCodeSelect = function HsCodeSelect(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    _ref$linerGroup = _ref.linerGroup,
    linerGroup = _ref$linerGroup === void 0 ? 'OOCL' : _ref$linerGroup,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var _useState = useState(false),
    fetching = _useState[0],
    setFetching = _useState[1];
  var _useState2 = useState([]),
    searchData = _useState2[0],
    setSearchData = _useState2[1];
  var _useState3 = useState(),
    selectedValue = _useState3[0],
    setSelectedValue = _useState3[1];
  var searchValueRef = useRef('');
  var searchByDesc = useCallback(debounce( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setFetching(true);
            _context.next = 3;
            return axios.request({
              method: 'get',
              withCredentials: true,
              url: "/ccdGateway/comi/commodity-library/hs-code-commodities/component/search",
              params: {
                desc: val,
                linerGroup: (linerGroup || '').toUpperCase()
              }
            });
          case 3:
            response = _context.sent;
            if (searchValueRef.current === val) {
              setSearchData(response.data || []);
            }
            setFetching(false);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), 800), [linerGroup]);
  useEffect(function () {
    setSearchData([]);
  }, [linerGroup]);
  var handleSearch = function handleSearch(searchVal) {
    searchValueRef.current = searchVal;
    if (!searchVal) {
      setSearchData([]);
    } else if (searchVal.length >= 2) {
      searchByDesc(searchVal);
    }
  };
  var dropdownRender = function dropdownRender(menu) {
    return fetching ? React.createElement(Spin, {
      style: {
        padding: '15px'
      },
      size: "small"
    }) : React.createElement(React.Fragment, null, React.createElement(Row, {
      style: {
        height: '30px',
        alignItems: 'center',
        backgroundColor: '#dfe4ea',
        padding: '0 10px',
        fontWeight: 'bold',
        color: '#2f3542',
        borderBottom: '1px solid #a4b0be'
      }
    }, React.createElement(Col, {
      flex: "100px"
    }, React.createElement(Row, null, "Code")), React.createElement(Col, {
      flex: "auto"
    }, React.createElement(Row, null, "Description"))), menu);
  };
  useEffect(function () {
    var newSelectedValue;
    if (!value) {
      newSelectedValue = value;
    } else if (isArray(value)) {
      newSelectedValue = value.map(function (val) {
        return {
          value: val.code,
          label: "" + [val.code, val.name].filter(function (v) {
            return v;
          }).join("-")
        };
      });
    } else {
      newSelectedValue = {
        value: value.code,
        label: "" + [value.code, value.name].filter(function (v) {
          return v;
        }).join("-")
      };
    }
    setSelectedValue(newSelectedValue);
  }, [value]);
  var handleChange = function handleChange(newSelectedValue) {
    var updatedValue;
    if (!newSelectedValue) {
      updatedValue = newSelectedValue;
    } else if (isArray(newSelectedValue)) {
      updatedValue = newSelectedValue.map(function (val) {
        return {
          code: val.value,
          name: val.label.replace(val.value + "-", '')
        };
      });
    } else {
      updatedValue = {
        code: newSelectedValue.value,
        name: newSelectedValue.label.replace(newSelectedValue.value + "-", '')
      };
    }
    onChange && onChange(updatedValue);
  };
  return React.createElement(React.Fragment, null, React.createElement(Select, Object.assign({
    value: selectedValue,
    showSearch: true,
    allowClear: true,
    onChange: handleChange,
    onSearch: handleSearch,
    filterOption: false,
    maxTagTextLength: 28,
    notFoundContent: fetching ? React.createElement(Spin, {
      style: {
        padding: '15px'
      },
      size: "small"
    }) : undefined,
    dropdownRender: dropdownRender,
    labelInValue: true,
    optionLabelProp: "label"
  }, restProps), searchData.map(function (item) {
    return React.createElement(Select.Option, {
      key: Math.random().toString(),
      value: item.code,
      label: item.code + "-" + item.name
    }, React.createElement(Row, {
      align: "middle",
      style: {
        flexWrap: 'nowrap'
      }
    }, React.createElement(Col, {
      flex: "100px"
    }, React.createElement(Row, null, item.code)), React.createElement(Col, {
      flex: "auto"
    }, React.createElement(Row, null, React.createElement("span", {
      title: item.name
    }, item.name)))));
  })));
};

var _excluded$8 = ["displayTpl", "linerGroup", "value", "onChange", "includeInactive", "dataSource", "mode", "supportAdvanceSearch"];
var AccessTypeEnum;
(function (AccessTypeEnum) {
  AccessTypeEnum["Public"] = "Public";
  AccessTypeEnum["Internal"] = "Internal";
})(AccessTypeEnum || (AccessTypeEnum = {}));
var CommodityLevelEnum;
(function (CommodityLevelEnum) {
  CommodityLevelEnum["Segment"] = "Segment";
  CommodityLevelEnum["Family"] = "Family";
  CommodityLevelEnum["Clazz"] = "Clazz";
  CommodityLevelEnum["Commodity"] = "Commodity";
})(CommodityLevelEnum || (CommodityLevelEnum = {}));
var SearchTypeEnum;
(function (SearchTypeEnum) {
  SearchTypeEnum["GroupName"] = "GroupName";
  SearchTypeEnum["Contains"] = "Contains";
  SearchTypeEnum["DoesNotContain"] = "DoesNotContain";
  SearchTypeEnum["CargoDesc"] = "CargoDesc";
})(SearchTypeEnum || (SearchTypeEnum = {}));
var GroupDetail = function GroupDetail(_ref) {
  var data = _ref.data;
  var getColor = function getColor(commodity) {
    if (commodity.level === CommodityLevelEnum.Commodity) {
      return "green";
    }
    if (commodity.level === CommodityLevelEnum.Clazz) {
      return "purple";
    }
    if (commodity.level === CommodityLevelEnum.Family) {
      return "blue";
    }
    if (commodity.level === CommodityLevelEnum.Segment) {
      return "orange";
    }
    return "red";
  };
  var countCmdyByLvl = function countCmdyByLvl(data, level) {
    return data.flatMap(function (cmdySet) {
      return cmdySet.commodities;
    }).filter(function (c) {
      return c.level === level;
    }).length;
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      marginLeft: "70px"
    }
  }, React.createElement(Row, {
    style: {
      marginBottom: "15px",
      flexWrap: "nowrap"
    }
  }, React.createElement(Col, {
    flex: "140px"
  }, React.createElement("span", {
    style: {
      color: "#485460"
    }
  }, "Contains", " ", isEmpty$1(data == null ? void 0 : data.commoditySet) ? "" : "(" + data.commoditySet.flatMap(function (cmdySet) {
    return cmdySet.commodities;
  }).length + ") ", ":"), React.createElement(Row, {
    style: {
      marginLeft: "2px",
      marginTop: "10px"
    }
  }, !isEmpty$1(data == null ? void 0 : data.commoditySet) && React.createElement(Col, {
    flex: "120px"
  }, React.createElement(Row, null, React.createElement(Space, {
    size: "small"
  }, React.createElement("div", {
    style: {
      width: "10px",
      height: "10px",
      backgroundColor: "#b7eb8f"
    }
  }), React.createElement("span", {
    style: {
      fontSize: "11px",
      color: "#636e72"
    }
  }, "Commodity (", countCmdyByLvl(data.commoditySet, CommodityLevelEnum.Commodity), ")"))), React.createElement(Row, null, React.createElement(Space, {
    size: "small"
  }, React.createElement("div", {
    style: {
      width: "10px",
      height: "10px",
      backgroundColor: "#d3adf7"
    }
  }), React.createElement("span", {
    style: {
      fontSize: "11px",
      color: "#636e72"
    }
  }, "Class (", countCmdyByLvl(data.commoditySet, CommodityLevelEnum.Clazz), ")"))), React.createElement(Row, null, React.createElement(Space, {
    size: "small"
  }, React.createElement("div", {
    style: {
      width: "10px",
      height: "10px",
      backgroundColor: "#91caff"
    }
  }), React.createElement("span", {
    style: {
      fontSize: "11px",
      color: "#636e72"
    }
  }, "Family (", countCmdyByLvl(data.commoditySet, CommodityLevelEnum.Family), ")"))), React.createElement(Row, null, React.createElement(Space, {
    size: "small"
  }, React.createElement("div", {
    style: {
      width: "10px",
      height: "10px",
      backgroundColor: "#ffd591"
    }
  }), React.createElement("span", {
    style: {
      fontSize: "11px",
      color: "#636e72"
    }
  }, "Segment (", countCmdyByLvl(data.commoditySet, CommodityLevelEnum.Segment), ")")))))), React.createElement(Col, {
    flex: "auto"
  }, React.createElement(Card, {
    style: {
      height: "250px",
      overflow: "auto"
    },
    bodyStyle: {
      padding: "10px"
    }
  }, ((data == null ? void 0 : data.keywordContained) || []).sort(function (a, b) {
    return a.text.localeCompare(b.text);
  }).map(function (k) {
    return React.createElement("div", {
      key: Math.random().toString()
    }, React.createElement("span", null, k.text), React.createElement("br", null));
  }), ((data == null ? void 0 : data.commoditySet) || []).map(function (cmdy, index) {
    return React.createElement("div", {
      key: Math.random().toString()
    }, React.createElement("span", {
      style: {
        fontWeight: "bold",
        color: "#57606f"
      }
    }, "Set ", index + 1, ":", " "), !isEmpty$1(cmdy.commodities) && React.createElement(React.Fragment, null, React.createElement("br", null), React.createElement("span", {
      style: {
        fontWeight: "bold",
        color: "#57606f"
      }
    }, "Commodities:", " "), cmdy.commodities.map(function (commodity) {
      return React.createElement(Tag, {
        key: Math.random().toString(),
        color: getColor(commodity),
        style: {
          marginBottom: "5px"
        }
      }, commodity.name);
    })), !isEmpty$1(cmdy.attributes) && React.createElement(React.Fragment, null, React.createElement("span", null, cmdy.attributes.map(function (attr, index) {
      return React.createElement("div", {
        key: index
      }, React.createElement("span", {
        style: {
          fontWeight: "bold",
          color: "#57606f"
        }
      }, attr.type + ": "), React.createElement("span", null, "" + attr.value.join(", ")), React.createElement("br", null));
    }))), React.createElement("br", null));
  })))), React.createElement(Row, {
    style: {
      marginBottom: "15px",
      flexWrap: "nowrap"
    }
  }, React.createElement(Col, {
    flex: "140px"
  }, React.createElement("span", {
    style: {
      color: "#485460"
    }
  }, "Does Not Contain :")), React.createElement(Col, {
    flex: "auto"
  }, React.createElement(Card, {
    style: {
      height: "100px",
      overflow: "auto"
    },
    bodyStyle: {
      padding: "10px"
    }
  }, ((data == null ? void 0 : data.keywordNotContained) || []).sort(function (a, b) {
    return a.text.localeCompare(b.text);
  }).map(function (k) {
    return React.createElement("div", {
      key: Math.random().toString()
    }, React.createElement("span", null, k.text), React.createElement("br", null));
  })))), React.createElement(Row, {
    style: {
      marginBottom: "10px",
      flexWrap: "nowrap"
    }
  }, React.createElement(Col, {
    flex: "140px"
  }, React.createElement("span", {
    style: {
      color: "#485460"
    }
  }, "Remarks :")), React.createElement(Col, {
    flex: "auto"
  }, React.createElement(Card, {
    style: {
      height: "50px",
      overflow: "auto"
    },
    bodyStyle: {
      padding: "10px"
    }
  }, (data == null ? void 0 : data.remark) || "")))));
};
var SearchResult = function SearchResult(_ref2) {
  var searchData = _ref2.searchData,
    dataMap = _ref2.dataMap,
    expandKeys = _ref2.expandKeys,
    setExpandKeys = _ref2.setExpandKeys,
    selectedKeys = _ref2.selectedKeys,
    setSelectedKeys = _ref2.setSelectedKeys,
    checkedKeys = _ref2.checkedKeys,
    setCheckedKeys = _ref2.setCheckedKeys,
    mode = _ref2.mode;
  var onSelectChange = function onSelectChange(selectedKeys) {
    setSelectedKeys(selectedKeys);
  };
  var onCheckChange = function onCheckChange(checked) {
    setCheckedKeys(checked.checked || []);
  };
  var groupDetailData = selectedKeys[0] && dataMap.get(selectedKeys[0]);
  var checkAll = dataMap.size === checkedKeys.length;
  var indeterminate = checkedKeys.length > 0 && checkedKeys.length < dataMap.size;
  var onCheckAllChange = function onCheckAllChange(e) {
    setCheckedKeys(e.target.checked ? [].concat(Array.from(dataMap.keys())) : []);
  };
  return React.createElement(React.Fragment, null, React.createElement(Space, {
    direction: "vertical",
    style: {
      display: "flex"
    }
  }, React.createElement(Row, {
    style: {
      flexWrap: "nowrap"
    }
  }, React.createElement(Col, {
    flex: "480px"
  }, React.createElement(Card, {
    style: {
      height: "430px",
      overflow: "auto"
    },
    title: "Related Group Terms",
    size: "small",
    headStyle: {
      color: "#57606f"
    },
    extra: searchData.length > 0 && mode && React.createElement(Checkbox, {
      indeterminate: indeterminate,
      onChange: onCheckAllChange,
      checked: checkAll
    }, "Check all")
  }, (searchData == null ? void 0 : searchData.length) === 0 ? React.createElement(Empty, {
    image: Empty.PRESENTED_IMAGE_SIMPLE,
    style: {
      marginTop: "130px"
    }
  }) : React.createElement(Tree, {
    showLine: true,
    expandedKeys: expandKeys,
    onExpand: setExpandKeys,
    selectedKeys: selectedKeys,
    onSelect: onSelectChange,
    treeData: searchData,
    checkedKeys: checkedKeys,
    checkStrictly: true,
    onCheck: onCheckChange,
    checkable: !!mode
  }))), React.createElement(Col, {
    flex: "auto"
  }, React.createElement(GroupDetail, {
    data: groupDetailData
  })))));
};
var buildTreeNodes = function buildTreeNodes(flatData) {
  if (isEmpty$1(flatData)) {
    return [];
  }
  var rootGroups = flatData.filter(function (group) {
    return isEmpty$1(group.parentId);
  }).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
  return buildChildrenTreeNodes(rootGroups, flatData);
};
var buildChildrenTreeNodes = function buildChildrenTreeNodes(rootNodes, allNodes) {
  if (isEmpty$1(rootNodes)) {
    return [];
  }
  var result = [];
  var _loop = function _loop() {
    var rootNode = _step.value;
    var node = buildNode(rootNode);
    var childrenNodes = allNodes.filter(function (item) {
      return eq(item.parentId, rootNode.id);
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
    node.children = buildChildrenTreeNodes(childrenNodes, allNodes);
    result.push(node);
  };
  for (var _iterator = _createForOfIteratorHelperLoose(rootNodes), _step; !(_step = _iterator()).done;) {
    _loop();
  }
  return result;
};
var buildLibTreeNode = function buildLibTreeNode(data) {
  return (data || []).map(function (g) {
    return {
      key: g.id,
      title: React.createElement("span", {
        style: {
          fontWeight: "bold",
          color: "#474787"
        }
      }, g.name)
    };
  });
};
var buildNode = function buildNode(dto) {
  var treeNode = {};
  treeNode.title = React.createElement("span", {
    style: {
      fontWeight: dto.isMatched ? "bold" : undefined,
      color: dto.isMatched ? "#474787" : undefined
    }
  }, dto.name);
  treeNode.key = dto.id;
  return treeNode;
};
var buildKwGroupDataMap = function buildKwGroupDataMap(data, result) {
  data.keywordGroups.forEach(function (d) {
    d.type = "KeywordGroup";
    result.set(d.id, d);
  });
  return result;
};
var buildLibGroupDataMap = function buildLibGroupDataMap(data, result) {
  data.libGroups.forEach(function (d) {
    d.type = "LibraryGroup";
    result.set(d.id, d);
  });
  return result;
};
var buildSourceTree = function buildSourceTree(data, dataSource) {
  var result = [];
  if (dataSource === "Both") {
    var keywordGroupRoot = {
      key: "KeywordGroupRoot",
      title: "Group by Keyword",
      selectable: false,
      checkable: false,
      children: buildTreeNodes(data.keywordGroups)
    };
    var libGroupRoot = {
      key: "LibGroupRoot",
      title: "Group by Lib",
      selectable: false,
      checkable: false,
      children: buildLibTreeNode(data.libGroups)
    };
    result.push(libGroupRoot, keywordGroupRoot);
  } else if (dataSource === "KeywordGroup") {
    result.push.apply(result, buildTreeNodes(data.keywordGroups));
  } else {
    result.push.apply(result, buildLibTreeNode(data.libGroups));
  }
  return result;
};
var buildSourceDataMap = function buildSourceDataMap(data, dataSource) {
  var result = new Map();
  if (dataSource === "Both") {
    var kwGroupDataMap = buildKwGroupDataMap(data, result);
    var libGroupDataMap = buildLibGroupDataMap(data, kwGroupDataMap);
    var keys = Array.from(libGroupDataMap.keys());
    keys.push("LibGroupRoot");
    keys.push("KeywordGroupRoot");
    return [libGroupDataMap, keys];
  } else if (dataSource === "KeywordGroup") {
    var _kwGroupDataMap = buildKwGroupDataMap(data, result);
    var _keys = Array.from(_kwGroupDataMap.keys());
    _keys.push("KeywordGroupRoot");
    return [_kwGroupDataMap, _keys];
  } else {
    var _libGroupDataMap = buildLibGroupDataMap(data, result);
    var _keys2 = Array.from(_libGroupDataMap.keys());
    _keys2.push("LibGroupRoot");
    return [_libGroupDataMap, _keys2];
  }
};
var compareVersions = function compareVersions(v1, v2) {
  var v1Parts = v1.split(".").map(Number);
  var v2Parts = v2.split(".").map(Number);
  for (var i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
    var part1 = v1Parts[i] || 0;
    var part2 = v2Parts[i] || 0;
    if (part1 > part2) return 1;
    if (part1 < part2) return -1;
  }
  return 0;
};
var isOpenPropVersion = /*#__PURE__*/compareVersions(version, "4.23.0") >= 0;
var modalOpenProp = isOpenPropVersion ? "open" : "visible";
var selectWidthPropVersion = /*#__PURE__*/compareVersions(version, "5.5.0") >= 0;
var selectWidthProp = selectWidthPropVersion ? "popupMatchSelectWidth" : "dropdownMatchSelectWidth";
var GroupConfirmationModal = function GroupConfirmationModal(_ref3) {
  var _modalOpenProps, _selectWidthProps;
  var linerGroup = _ref3.linerGroup,
    isOpen = _ref3.isOpen,
    setOpen = _ref3.setOpen,
    handleConfirmGroup = _ref3.handleConfirmGroup,
    mode = _ref3.mode,
    dataSource = _ref3.dataSource;
  var _Form$useForm = Form.useForm(),
    searchCriteriaForm = _Form$useForm[0];
  var _useState = useState([]),
    searchData = _useState[0],
    setSearchData = _useState[1];
  var _useState2 = useState(new Map()),
    dataMap = _useState2[0],
    setDataMap = _useState2[1];
  var _useState3 = useState(false),
    searchLoading = _useState3[0],
    setSearchLoading = _useState3[1];
  var _useState4 = useState([]),
    expandKeys = _useState4[0],
    setExpandKeys = _useState4[1];
  var _useState5 = useState([]),
    selectedKeys = _useState5[0],
    setSelectedKeys = _useState5[1];
  var _useState6 = useState([]),
    checkedKeys = _useState6[0],
    setCheckedKeys = _useState6[1];
  var onSearch = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            buildSearchResult(searchCriteriaForm.getFieldsValue());
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSearch() {
      return _ref4.apply(this, arguments);
    };
  }();
  var buildSearchResult = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(searchCriteria) {
      var _searchCriteria$group, result, _buildSourceDataMap, _dataMap, keys;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setSearchLoading(true);
            if (isEmpty$1(dataSource)) {
              _context2.next = 9;
              break;
            }
            _context2.next = 4;
            return axios.request({
              method: "post",
              withCredentials: true,
              headers: {
                "Liner-Group": linerGroup.toUpperCase()
              },
              url: "/ccdGateway/comi/commodity-library/customized-groups/search",
              data: {
                searchType: searchCriteria.searchType,
                text: searchCriteria.text || ((_searchCriteria$group = searchCriteria.groupCodeName) == null ? void 0 : _searchCriteria$group.name)
              }
            });
          case 4:
            result = _context2.sent;
            _buildSourceDataMap = buildSourceDataMap(result.data, dataSource), _dataMap = _buildSourceDataMap[0], keys = _buildSourceDataMap[1];
            setDataMap(_dataMap);
            setSearchData(buildSourceTree(result.data, dataSource));
            setExpandKeys(keys);
          case 9:
            setSelectedKeys([]);
            setCheckedKeys([]);
            setSearchLoading(false);
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function buildSearchResult(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var reset = function reset() {
    searchCriteriaForm.resetFields();
    setSearchData([]);
    setExpandKeys([]);
    setDataMap(new Map());
    setSelectedKeys([]);
    setCheckedKeys([]);
  };
  var handleOk = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var groups, group;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (mode) {
              groups = checkedKeys.map(function (key) {
                return dataMap.get(key);
              });
              handleConfirmGroup(groups);
            } else {
              group = dataMap.get(selectedKeys[0]);
              handleConfirmGroup(group);
            }
            setOpen(false);
            reset();
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleOk() {
      return _ref6.apply(this, arguments);
    };
  }();
  var handleCancel = function handleCancel() {
    setOpen(false);
    reset();
  };
  var modalOpenProps = (_modalOpenProps = {}, _modalOpenProps[modalOpenProp] = isOpen, _modalOpenProps);
  var selectWidthProps = (_selectWidthProps = {}, _selectWidthProps[selectWidthProp] = 500, _selectWidthProps);
  // @ts-ignore
  var searchType = Form.useWatch("searchType", searchCriteriaForm);
  return React.createElement(React.Fragment, null, React.createElement(Modal, Object.assign({
    title: "Find Group Information"
  }, modalOpenProps, {
    onOk: handleOk,
    onCancel: handleCancel,
    width: 1200,
    okText: "Confirm",
    okButtonProps: {
      disabled: mode ? checkedKeys.length === 0 : selectedKeys.length === 0
    },
    destroyOnClose: true
  }), React.createElement(Spin, {
    spinning: searchLoading
  }, React.createElement(Card, {
    title: "Search Criteria",
    size: "small",
    style: {
      marginBottom: "15px"
    }
  }, React.createElement(Form, {
    style: {
      maxWidth: "100%"
    },
    wrapperCol: {
      span: 21
    },
    layout: "vertical",
    form: searchCriteriaForm,
    onFinish: onSearch
  }, React.createElement(Row, null, React.createElement(Col, {
    span: 8
  }, React.createElement(Form.Item, {
    label: "Type",
    name: "searchType",
    rules: [{
      type: "string",
      required: true,
      message: "Please input mandatory field."
    }]
  }, React.createElement(Select, {
    options: [{
      value: SearchTypeEnum.GroupName,
      label: "Group Name"
    }, {
      value: SearchTypeEnum.Contains,
      label: "Contains"
    }, {
      value: SearchTypeEnum.DoesNotContain,
      label: "Does Not Contain"
    }, {
      value: SearchTypeEnum.CargoDesc,
      label: "Cargo Description"
    }],
    placeholder: "Please select"
  }))), React.createElement(Col, {
    span: 8
  }, searchType === SearchTypeEnum.GroupName ? React.createElement(Form.Item, {
    label: "Text",
    name: "groupCodeName",
    rules: [{
      type: "object",
      required: true,
      message: "Please input mandatory field."
    }]
  }, React.createElement(CommodityGroupSelect, Object.assign({
    dataSource: dataSource,
    linerGroup: linerGroup,
    placeholder: "Please input"
  }, selectWidthProps))) : React.createElement(Form.Item, {
    label: "Text",
    name: "text",
    rules: [{
      type: "string",
      required: true,
      message: "Please input mandatory field."
    }]
  }, React.createElement(Input, {
    placeholder: "Please select"
  })))), React.createElement(Row, {
    justify: "end"
  }, React.createElement(Space, null, React.createElement(Button, {
    htmlType: "reset"
  }, "Reset"), React.createElement(Button, {
    type: "primary",
    htmlType: "submit"
  }, "Search"))))), React.createElement(Card, {
    title: "Search Result",
    size: "small"
  }, React.createElement(SearchResult, {
    searchData: searchData,
    dataMap: dataMap,
    expandKeys: expandKeys,
    setExpandKeys: setExpandKeys,
    selectedKeys: selectedKeys,
    setSelectedKeys: setSelectedKeys,
    checkedKeys: checkedKeys,
    setCheckedKeys: setCheckedKeys,
    mode: mode
  })))));
};
var CommodityGroupSelect = function CommodityGroupSelect(_ref7) {
  var displayTpl = _ref7.displayTpl,
    linerGroup = _ref7.linerGroup,
    value = _ref7.value,
    onChange = _ref7.onChange,
    _ref7$includeInactive = _ref7.includeInactive,
    includeInactive = _ref7$includeInactive === void 0 ? false : _ref7$includeInactive,
    _ref7$dataSource = _ref7.dataSource,
    dataSource = _ref7$dataSource === void 0 ? "Both" : _ref7$dataSource,
    mode = _ref7.mode,
    _ref7$supportAdvanceS = _ref7.supportAdvanceSearch,
    supportAdvanceSearch = _ref7$supportAdvanceS === void 0 ? false : _ref7$supportAdvanceS,
    restProps = _objectWithoutPropertiesLoose(_ref7, _excluded$8);
  var _useState7 = useState(),
    selectedValue = _useState7[0],
    setSelectedValue = _useState7[1];
  var _useState8 = useState([]),
    groups = _useState8[0],
    setGroups = _useState8[1];
  var _useState9 = useState(false),
    loading = _useState9[0],
    setLoading = _useState9[1];
  var searchValueRef = useRef("");
  var searchByDesc = useCallback(debounce( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(val) {
      var response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            setLoading(true);
            _context4.next = 3;
            return axios.request({
              method: "get",
              withCredentials: true,
              url: "/ccdGateway/comi/commodity-library/commodity-groups/component/search",
              headers: {
                "Liner-Group": linerGroup
              },
              params: {
                includeInactive: includeInactive,
                name: val,
                dataSource: dataSource
              }
            });
          case 3:
            response = _context4.sent;
            if (searchValueRef.current === val) {
              setGroups(response.data || []);
            }
            setLoading(false);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x2) {
      return _ref8.apply(this, arguments);
    };
  }(), 800), [includeInactive, dataSource, linerGroup]);
  var handleSearch = function handleSearch(searchVal) {
    searchValueRef.current = searchVal;
    if (!searchVal) {
      setGroups([]);
    } else if (searchVal.length >= 2) {
      searchByDesc(searchVal);
    }
  };
  var buildDisplayTag = function buildDisplayTag(item) {
    if (displayTpl) {
      return displayTpl(item);
    }
    return item.name;
  };
  var buildLabelValue = function buildLabelValue(item) {
    return item.code + ":::" + item.name + ":::" + item.type;
  };
  useEffect(function () {
    var newSelectedValue;
    if (!value) {
      newSelectedValue = value;
    } else if (isArray(value)) {
      newSelectedValue = value.map(function (val) {
        return {
          value: val.code + (":::" + val.name) + ("" + (val.type ? ":::" + val.type : "")),
          label: buildDisplayTag(val)
        };
      });
    } else {
      newSelectedValue = {
        value: value.code + (":::" + value.name) + ("" + (value.type ? ":::" + value.type : "")),
        label: buildDisplayTag(value)
      };
    }
    setSelectedValue(newSelectedValue);
  }, [value]);
  var handleChange = function handleChange(newSelectedValue) {
    var updatedValue;
    if (!newSelectedValue) {
      updatedValue = newSelectedValue;
    } else if (isArray(newSelectedValue)) {
      updatedValue = uniqBy(newSelectedValue.map(function (val) {
        var typeCodeName = val.value.split(":::");
        return {
          code: typeCodeName[0],
          name: typeCodeName[1],
          type: typeCodeName[2]
        };
      }), "code");
    } else {
      var typeCode = newSelectedValue.value.split(":::");
      updatedValue = {
        code: typeCode[0],
        name: typeCode[1],
        type: typeCode[2]
      };
    }
    onChange && onChange(updatedValue);
  };
  var handleConfirmGroup = function handleConfirmGroup(group) {
    if (isArray(group)) {
      var newSelectedValue = [].concat(selectedValue || [], group.map(function (g) {
        return {
          value: buildLabelValue(g),
          label: buildDisplayTag(g)
        };
      }));
      handleChange(newSelectedValue);
    } else {
      handleChange({
        value: buildLabelValue(group),
        label: buildDisplayTag(group)
      });
    }
  };
  var _useState10 = useState(false),
    openConfirmationModal = _useState10[0],
    setOpenConfirmationModal = _useState10[1];
  var dropdownRender = function dropdownRender(menu) {
    return loading ? React.createElement(Spin, {
      style: {
        padding: "15px"
      },
      size: "small"
    }) : React.createElement(React.Fragment, null, React.createElement(Row, {
      style: {
        height: "30px",
        alignItems: "center",
        backgroundColor: "#dfe4ea",
        padding: "0 10px",
        fontWeight: "bold",
        color: "#2f3542",
        borderBottom: "1px solid #a4b0be"
      }
    }, React.createElement(Col, {
      flex: "auto",
      style: {
        maxWidth: "calc(100% - 130px)"
      }
    }, React.createElement(Row, null, "Name")), React.createElement(Col, {
      flex: "130px"
    }, React.createElement("span", null, "Type"))), menu);
  };
  var groupSelect = React.createElement(Select, Object.assign({
    showSearch: true,
    allowClear: true,
    value: selectedValue,
    onChange: handleChange,
    onSearch: handleSearch,
    filterOption: false,
    notFoundContent: loading ? React.createElement(Spin, {
      style: {
        padding: "15px"
      },
      size: "small"
    }) : undefined,
    dropdownRender: dropdownRender,
    labelInValue: true,
    mode: mode,
    optionLabelProp: "label"
  }, restProps), (groups || []).map(function (item) {
    return React.createElement(Select.Option, {
      key: Math.random().toString(),
      value: buildLabelValue(item),
      label: buildDisplayTag(item)
    }, React.createElement(Row, {
      align: "middle",
      style: {
        flexWrap: "nowrap"
      }
    }, React.createElement(Col, {
      flex: "auto",
      style: {
        maxWidth: "calc(100% - 130px)"
      }
    }, React.createElement("div", {
      style: {
        textOverflow: "ellipsis",
        overflowX: "hidden",
        paddingRight: "2px"
      }
    }, React.createElement("span", {
      title: item.name
    }, item.name))), React.createElement(Col, {
      flex: "120px"
    }, React.createElement(Row, null, React.createElement("span", null, item.type === "KeywordGroup" ? "Group by Keyword" : "Group by Library")))));
  }));
  return React.createElement(React.Fragment, null, supportAdvanceSearch ? React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, groupSelect, React.createElement(Button, {
    icon: React.createElement(SearchOutlined, null),
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    },
    onClick: function onClick() {
      return setOpenConfirmationModal(true);
    }
  }), React.createElement(GroupConfirmationModal, {
    isOpen: openConfirmationModal,
    setOpen: setOpenConfirmationModal,
    handleConfirmGroup: handleConfirmGroup,
    mode: mode,
    dataSource: dataSource,
    linerGroup: linerGroup
  })) : groupSelect);
};

var _excluded$9 = ["linerGroup", "value", "onChange", "sort"];
function initCommonData$1(setItems, linerGroup) {
  var options = containerSizeTypeRequest(linerGroup);
  var key = getWholeUrlFromOptions(options);
  var oneDayInMs = 1000 * 60 * 60 * 24;
  var db = new Dexie('ccdDB');
  db.version(1).stores({
    ccdTable: ''
  });
  db.table('ccdTable').get(key).then(function (cache) {
    if (cache && new Date().getTime() - cache.cacheTime < oneDayInMs) {
      setItems(cache.data);
    } else {
      axios(options).then(function (response) {
        setItems(response.data.results);
        db.table('ccdTable').put({
          data: response.data.results,
          cacheTime: new Date().getTime()
        }, key);
      });
    }
  })["catch"](function () {
    axios(options).then(function (response) {
      setItems(response.data.results);
    });
  });
}
var constructContainerTypeValue = function constructContainerTypeValue(value, type) {
  return {
    type: type,
    value: value
  };
};
var getContainerGroupByContainerSizeLength = function getContainerGroupByContainerSizeLength(items) {
  var containers = [];
  items.forEach(function (item) {
    var _item$size;
    containers.push({
      containerSizeLength: item == null || (_item$size = item.size) == null ? void 0 : _item$size.length,
      containerSizeTypeCode: item == null ? void 0 : item.sizeTypeCode
    });
  });
  var sortContainers = containers.sort(function (a, b) {
    return a.containerSizeLength.localeCompare(b.containerSizeLength);
  });
  return groupBy$1(sortContainers, 'containerSizeLength');
};
var getContainerTreeOption = function getContainerTreeOption(title, value) {
  return {
    title: title,
    value: value,
    label: value,
    key: value
  };
};
var constructContainerTree = function constructContainerTree(items) {
  var containerGroup = getContainerGroupByContainerSizeLength(items);
  var containerTree = [_extends({}, getContainerTreeOption('All Containers', 'All'), {
    children: []
  })];
  Object.keys(containerGroup).forEach(function (key) {
    var children = [];
    containerGroup[key].forEach(function (container) {
      children.push(getContainerTreeOption(container.containerSizeTypeCode, container.containerSizeTypeCode));
    });
    containerTree[0].children.push(_extends({}, getContainerTreeOption(key, key), {
      children: children
    }));
  });
  return containerTree;
};
var constructContainerTypeValues = function constructContainerTypeValues(items) {
  var containerGroup = getContainerGroupByContainerSizeLength(items);
  var containerTypeValues = [];
  containerTypeValues.push(constructContainerTypeValue("All", 'All'));
  Object.keys(containerGroup).forEach(function (key) {
    containerTypeValues.push(constructContainerTypeValue(key, 'ContainerSizeLength'));
    containerGroup[key].forEach(function (container) {
      containerTypeValues.push(constructContainerTypeValue(container.containerSizeTypeCode, 'ContainerSizeType'));
    });
  });
  return containerTypeValues;
};
var containerSizeTypeRequest = function containerSizeTypeRequest(linerGroup) {
  return {
    method: 'GET',
    baseURL: '/ccdGateway',
    params: {
      category: 'containerSizeType',
      memship: '',
      linerGroup: linerGroup
    },
    url: "/cmn/data",
    withCredentials: true
  };
};
var getSortValuesFromContainerTypeValues = function getSortValuesFromContainerTypeValues(containerTypeValues, type) {
  var typeValues = (containerTypeValues || []).filter(function (containerTypeValue) {
    return containerTypeValue.type === type;
  });
  typeValues.sort(function (a, b) {
    return a.value.localeCompare(b.value);
  });
  return typeValues;
};
var getContainerValue = function getContainerValue(containerTypeValues) {
  return (containerTypeValues || []).map(function (containerTypeValue) {
    return containerTypeValue.value;
  });
};
var sortTypeValues = function sortTypeValues(sort, containerTypeValues) {
  var _containerTypeValues$;
  if (sort) {
    return sort(containerTypeValues);
  }
  if ((containerTypeValues == null || (_containerTypeValues$ = containerTypeValues[0]) == null ? void 0 : _containerTypeValues$.value) === 'All') {
    return containerTypeValues;
  }
  var sortSizeLengthValues = getSortValuesFromContainerTypeValues(containerTypeValues, 'ContainerSizeLength');
  var sortSizeTypeValues = getSortValuesFromContainerTypeValues(containerTypeValues, 'ContainerSizeType');
  return sortSizeLengthValues.concat(sortSizeTypeValues);
};
var ContainerTreeSelect = function ContainerTreeSelect(_ref) {
  var linerGroup = _ref.linerGroup,
    value = _ref.value,
    onChange = _ref.onChange,
    sort = _ref.sort,
    remainProps = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  var _useState = useState([]),
    items = _useState[0],
    setItems = _useState[1];
  var _useState2 = useState([]),
    containerTree = _useState2[0],
    setContainerTree = _useState2[1];
  var _useState3 = useState([]),
    containerTypeValues = _useState3[0],
    setContainerTypeValues = _useState3[1];
  var _useState4 = useState(true),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState([]),
    initValues = _useState5[0],
    setInitValues = _useState5[1];
  useEffect(function () {
    setLoading(true);
    initCommonData$1(setItems, linerGroup);
    var typeValues = sortTypeValues(sort, value || []);
    setInitValues(getContainerValue(typeValues));
  }, [linerGroup]);
  useEffect(function () {
    if (items.length > 0) {
      setContainerTree(constructContainerTree(items));
      setContainerTypeValues(constructContainerTypeValues(items));
      setLoading(false);
    }
  }, [items]);
  var onContainerChange = function onContainerChange(value) {
    var matchedTypeValues = (containerTypeValues || []).filter(function (containerTypeValue) {
      return value.some(function (v) {
        return v === containerTypeValue.value;
      });
    });
    var sortedTypeValues = sortTypeValues(sort, matchedTypeValues);
    setInitValues(getContainerValue(sortedTypeValues));
    onChange == null || onChange(sortedTypeValues);
  };
  return loading ? React.createElement(TreeSelect, {
    notFoundContent: React.createElement(Spin, {
      size: "small"
    })
  }) : React.createElement(TreeSelect, Object.assign({
    treeData: containerTree,
    treeCheckable: true,
    treeDefaultExpandAll: true,
    style: {
      width: '100%'
    },
    showCheckedStrategy: TreeSelect.SHOW_PARENT,
    value: initValues,
    onChange: onContainerChange
  }, remainProps));
};

var SSCSStowageSelect = function SSCSStowageSelect(props) {
  return React.createElement(CmnDataSelect, Object.assign({
    displayField: 'name',
    valueField: 'id',
    url: '/sscs/sscs-rule-engine/special-stowage-types/select'
  }, props));
};

export { AgreementSelect, CmnDataSelect, CmnPrinterSelect, CommodityGroupSelect, CommoditySelect, ContainerTreeSelect, CusCustomerSelect, GspGeoSelect, GspOrgSelect, HsCodeSelect, IrisSelect, ItsServiceLoopSelect, ItsSvvdSelect, ItsVesselOperatorSelect, ItsVesselSelect, LocationTypeSelect, SSCSStowageSelect, SalesSelect, SppmSupplierSelect, TariffDataSelect, UserSelect };
//# sourceMappingURL=ccd-react-cmp.esm.js.map
